














































































































































import { Component, Mixins, Vue } from "vue-property-decorator";
import { postCollectCharge, getCourses, postActionLog } from "@/apis";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import CurrentPoint from "@/components/CurrentPoint.vue";
import PopupDialog from "@/components/PopupDialog.vue";
import Overlay from "@/components/Overlay.vue";
import TextLabel from "@/components/TextLabel.vue";
import SettingMixin from "@/mixins/settingMixin";
import { CourseGroups, COURSE_APPLY_STATE } from "@/apis";
import {
  URL_PARAM_SERIAL_CODE,
  URL_PARAM_REDIRECT_CODE,
  URL_PARAM_TOKEN,
  URL_PARAM_TRAN_SRC,
} from "@/utils/url";

@Component({
  components: {
    ContainImage,
    ImageButton,
    TextLabel,
    CurrentPoint,
    PopupDialog,
    Overlay,
  },
})
export default class MyPage extends Mixins(Vue, SettingMixin) {
  ownedCount: number | null = null;
  isWin: boolean | undefined = undefined;
  isMounted = false;
  isPeriodError = false;

  async mounted(): Promise<void> {
    const isOpen = await this.checkCampaignStatus();
    if (!isOpen) return;

    postActionLog(this.campaignId, this.token, this.serialCode, null, "login");

    // 応募コース取得
    const res = await getCourses(this.campaignId, this.token).catch((err) => {
      console.log(err);
      // 各種エラー
      this.showErrorDialog(this.responseError(err));
      return;
    });

    if (!res) return;
    this.ownedCount = res.data.owned_count;

    const applyNg = res.data.course_groups.find(
      (x: CourseGroups) =>
        x.course_group_apply_state !== COURSE_APPLY_STATE.ApplyOk
    );

    this.isWin = !!applyNg;
    this.$nextTick(function () {
      this.$forceUpdate();
    });

    // シール貯める
    const serialCode =
      (this.$route.query[URL_PARAM_SERIAL_CODE] as string) ?? "";
    if (serialCode.length > 0) {
      const chargeRes = await postCollectCharge(
        this.campaignId,
        this.token,
        serialCode
      ).catch((err) => {
        this.isPeriodError = err.response.data.code === 2024;
        // 各種エラー
        this.showErrorDialog(this.responseError(err));
        this.$router.replace({
          query: {
            [URL_PARAM_SERIAL_CODE]: "",
            [URL_PARAM_REDIRECT_CODE]: this.redirectCode,
            [URL_PARAM_TOKEN]: this.token,
            [URL_PARAM_TRAN_SRC]: this.transitionSrc,
          },
        });
        return;
      });

      if (!chargeRes) return;

      this.ownedCount = chargeRes.data.owned_count;
      this.refs.collectDialog.show();

      this.$router.replace({
        query: {
          [URL_PARAM_SERIAL_CODE]: "",
          [URL_PARAM_REDIRECT_CODE]: this.redirectCode,
          [URL_PARAM_TOKEN]: this.token,
          [URL_PARAM_TRAN_SRC]: this.transitionSrc,
        },
      });
    } else {
      this.ownedCount = res.data.owned_count;
      this.isMounted = true;
    }
  }

  hasShown(): void {
    this.isMounted = true;
  }

  onClickToInKindCoursePage(): void {
    if (!this.isMounted) return;
    this.pushWithTransition(this.routerPushCollabCoursesPage);
  }
  onClickToLINECoursePage(): void {
    if (!this.isMounted) return;
    this.pushWithTransition(this.routerPushLineCoursesPage);
  }

  onClickToCampaignPage(): void {
    if (!this.isMounted) return;
    this.routerPushCampaignPage();
  }
  onClickToRequestHistoryPage(): void {
    if (!this.isMounted) return;
    this.pushWithTransition(this.routerPushRequestHistoryPage);
  }
  onClickToCollectionHistoryPage(): void {
    if (!this.isMounted) return;
    this.pushWithTransition(this.routerPushCollectionHistoryPage);
  }
  get itemText(): string {
    return "「カルピスウォーター（R）」500ml<br />「カルピスソーダ（R）」500ml<br />「カルピス（R）THE RICH」490ml<br />";
  }
}
